const { baseBUCGet } = require('../base/baseBUC');

const int = 0;
const str = '';
const dateTimeStr = new Date()?.toISOString();

const informativeBillboardModelGet = ({ buildingId = '', apartmentId = '', userId = '', }) => {
    return {
        apartmentId: apartmentId,
        comment: str,
        iconName: str,
        iconPath: str,
        title: str,
        type: int,
        status: int,
        statusComment: str,
        statusDate: dateTimeStr,
        statusUserId: str,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};

module.exports = {
    informativeBillboardModelGet,
}